import { FEATURE_LIST } from '@/pages/home/data';

export default function Digging() {
  return (
    <section id="digging" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-16 md:px-6 md:py-24">
      {/* header */}
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            05 · 深扒专题
          </div>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            深扒专题 · 不只吃瓜
          </h2>
          <p className="mt-2 max-w-lg text-sm text-foreground-600">
            翻车现场看热闹，深扒专题看门道：话术怎么套现、结论怎么造假、风向怎么变。
          </p>
        </div>
      </div>

      {/* features */}
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {FEATURE_LIST.map((f, i) => (
          <a
            key={f.title}
            href="#hot"
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100/40 transition-all hover:border-primary-300"
          >
            {/* cover */}
            <div className="relative aspect-[4/3] w-full overflow-hidden">
              <img
                src={f.cover}
                alt={`抖阴深扒专题·${f.label}`}
                title={`抖阴深扒专题 · ${f.label}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-background-950/75 px-3 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                专题 · {String(i + 1).padStart(2, '0')}
              </span>
            </div>
            {/* body */}
            <div className="flex flex-1 flex-col p-5">
              <span className="text-xs font-semibold tracking-wide text-primary-600">{f.label}</span>
              <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {f.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{f.digest}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                深扒全文
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}